import { Input } from "@brg/input";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Wrapper } from "./styles";
import { ProjectEditPageGridLabel } from "shared/pages/projectEdit/styles";
import { FlexBox } from "@brg/ui";
import { BilingLabel } from "shared/pages/projectEdit/styles";

export const ProtectSection: FC<{ 
    value: boolean, 
    onChange: (val: boolean) => void, 
    customStyles: any, 
    disable?: boolean  
}> = ({ 
    value, 
    onChange, 
    customStyles, 
}) => {
    const { t } = useTranslation();

    return (
        <Wrapper direction="column" gy={12}>
            <ProjectEditPageGridLabel {...customStyles} className={'books-label'}>
            {t('payment.protect_book_mask')}
            </ProjectEditPageGridLabel>
            <FlexBox direction="row" directionMobile="row">
                <Input.Checkbox
                    title={''}
                    className={'competition-checkbox'}
                    checked={value}
                    onChange={(ev) => onChange(!value)}
                />
                <FlexBox offsetLeft={8} offsetLeftMobile={8} align="center">
                    <BilingLabel className="biling-label">{t('payment.protect_book_mask_info')}</BilingLabel>
                </FlexBox>
            </FlexBox>
        </Wrapper>
    )
}import { Input } from "@brg/input";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Wrapper } from "./styles";
import { ProjectEditPageGridLabel } from "shared/pages/projectEdit/styles";
import { FlexBox } from "@brg/ui";
import { BilingLabel } from "shared/pages/projectEdit/styles";

export const ProtectSection: FC<{ 
    value: boolean, 
    onChange: (val: boolean) => void, 
    customStyles: any, 
    disable?: boolean  
}> = ({ 
    value, 
    onChange, 
    customStyles, 
}) => {
    const { t } = useTranslation();

    return (
        <Wrapper direction="column" gy={12}>
            <ProjectEditPageGridLabel {...customStyles} className={'books-label'}>
            {t('payment.protect_book_mask')}
            </ProjectEditPageGridLabel>
            <FlexBox direction="row" directionMobile="row">
                <Input.Checkbox
                    title={''}
                    className={'competition-checkbox'}
                    checked={value}
                    onChange={(ev) => onChange(!value)}
                />
                <FlexBox offsetLeft={8} offsetLeftMobile={8} align="center">
                    <BilingLabel className="biling-label">{t('payment.protect_book_mask_info')}</BilingLabel>
                </FlexBox>
            </FlexBox>
        </Wrapper>
    )
}